import GlbFileImage from '../icons/glb_file_icon.svg';

interface ModelUploadWithSearchProps {
    onFormSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
    onFileUploadClick: () => void;
    onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onSearchInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const ModelUploadWithSearch = ({ onFormSubmit, onFileUploadClick, onFileChange, onSearchInputChange }: ModelUploadWithSearchProps) => {
    return (
        <div className="w-auto flex flex-col items-center justify-center gap-4">
            <div>
                <div className="flex justify-center items-center mb-2">
                    <img src={GlbFileImage} alt="glbfile" />
                </div>

                {/* <form onSubmit={onFormSubmit}>
                    <input type="text" placeholder="Search FSNs" className="w-full px-4 py-2 bg-gray-200 rounded-2xl outline-none text-gray-900 border-gray-100" onChange={onSearchInputChange} />
                </form> */}
                <div className="mt-0 mb-0">
                    <button type="button" style={{ color: '#2A55E5', fontWeight: 600, fontSize: '18px' }} onClick={onFileUploadClick}>
                        Drag & Drop your files or click here to select them
                    </button>
                    <input type="file" accept=".glb" id="fileInput" className="hidden" onChange={onFileChange} name="file" multiple />
                </div>

                <p style={{ color: '#717478', fontWeight: 300, fontSize: '16px', margin: 0, padding: 0 }}>
                    File should be under 6MB with 1k textures <br />
                    {/* <a href={SAMPLE_CSV_URL} className="relative text-blue-600 underline" target="_blank" rel="noreferrer">
                Sample Format here
            </a> */}
                </p>
            </div>
        </div>
    );
};

export default ModelUploadWithSearch;
